const orderingManagement = {
  error_messages: {
    page_title: 'Ordering error messages | Thanx',
    title: 'Ordering error messages',
    section_header: 'Most common error messages from %{provider}',
    subtitle:
      'These are the most frequently encountered errors from %{provider}, listed by frequency. You can customize how each message appears to your customers to create a more consistent, branded experience.',
    ready_to_go_live: 'Ready to go live?',
    publish_hint:
      "Hit the 'Publish' button to save changes and push them to your app or website.",
    unsaved_changes_hint:
      'You have unsaved changes. These changes will not be visible to customers until you publish.',
    publish: 'Publish',
    publishing: 'Publishing...',
    publish_success: 'Your error message customizations have been published.',
    publish_error:
      'There was an error publishing your changes. Please try again.',
    no_changes: 'No changes to publish.',
    unsaved_modal_title: 'You have unsaved changes',
    unsaved_modal_description:
      'Your changes have not been published and will be lost if you leave this page.',
    unsaved_modal_discard: 'Discard changes',
    unsaved_modal_publish: 'Publish & leave',
    generate_with_ai: 'Generate with ThanxAI',
    default_message_hint:
      'If no custom message is provided, the default %{provider} message will be shown.',
    brand_tone_saved: 'Brand tone saved.',
    brand_tone_save_failed: 'Failed to save brand tone.',
    ai_generation_success:
      'AI suggestions generated. Review them below before publishing.',
    ai_generation_error:
      'There was an error generating AI suggestions. Please try again.',
    ai_no_suggestions_for_category:
      'No AI suggestion was generated for this category. Please try again.',
    load_error_title: 'Unable to load error messages',
    load_error_content:
      'There was an error loading the error message configuration. Please try again later.',
    default_message_from_provider: 'Default error message from %{provider}',
    appears_as: 'Appears as:',
    appears_as_report:
      'Appears as: \u201C%{category}\u201D in the Unaccepted Carts report',
    unaccepted_carts_report: 'Unaccepted Carts report',
    generating_with_ai: 'Generating with AI...',
    enter_custom_message: 'Enter your custom message',
    revert_to_saved: 'Revert to saved',
    ai_wand_label: 'Generate with AI',
    pill_ai_personalized: 'AI personalized',
    pill_customized: 'Customized',
    in_the: 'in the',
    provider_fallback: 'your ordering provider',
  },
  location_list: {
    page_title: 'Ordering management | Thanx',
    title: 'Ordering management',
    locations: 'Locations',
    subtitle:
      'These locations are ingested from your ordering provider. View each location to troubleshoot errors.',
    table: {
      headers: {
        location: 'Location',
        menu_status: 'Menu status',
        ordering_status: 'Ordering status',
      },
      select_all: 'Select all',
      deselect_all: 'Deselect all',
    },
    enable_selected_locations: 'Enable selected locations',
    disable_selected_locations: 'Disable selected locations',
    modal: {
      title: '%{action} ordering at selected locations',
      content_enable:
        'Customers will immediately see these locations as available for ordering in your app or web experiences.',
      content_disable:
        'Customers will immediately not see these locations as available for ordering in your app or web experiences.',
      cancel: 'Cancel',
      confirm: '%{action} ordering',
      disable_warning: 'Orders currently in progress could be disrupted.',
    },
    alert: {
      enable_success: 'Ordering has been enabled at selected locations',
      disable_success: 'Ordering has been disabled at selected locations',
    },
    help: {
      title: 'Help',
      description: 'How to troubleshoot menu errors',
      enable_disable_locations: 'How to enable and disable locations',
    },
  },
  errors: '%{count} errors',
  no_errors: 'No errors',
  order_status: {
    enabled: 'Ordering enabled',
    disabled: 'Ordering disabled',
    not_configured: 'Ordering not configured',
  },
  view: 'View',
  disable_ordering_at_location: 'Disable ordering at this location',
  enable_ordering_at_location: 'Enable ordering at this location',
  detail: {
    title: '%{name} Ordering management | Thanx',
    header: {
      enabled: 'Ordering Enabled',
      disabled: 'Ordering Disabled',
      not_configured: 'Ordering not Configured',
      button: {
        enabled: 'Disable ordering at this location',
        disabled: 'Enable ordering at this location',
        not_configured: 'Enable ordering at this location',
      },
    },
    modal: {
      enable: {
        title: 'Enable ordering at selected locations',
        description:
          'Customers will immediately see these locations as available for ordering in your app or web experiences.',
        confirm_text: 'Enable ordering',
        success: 'Ordering has been enabled at this location',
      },
      disable: {
        title: 'Disable ordering at this location',
        description:
          '<p class="mb-m">Customers will immediately not see this location as available for ordering in your app or web experiences.</p> <p class="cayenne-50">Orders currently in progress could be disrupted.</p>',
        confirm_text: 'Disable ordering',
        success: 'Ordering has been disabled at this location',
      },
    },
    update: {
      last_updated: 'Last updated',
      update: 'Update',
    },
    popover:
      'Updates may take up to a minute after clicking “Update”. Automatic updates happen every 15 minutes.',
    errors: {
      title: 'Errors associated with this location',
    },
    schedule_overrides: {
      title: 'Upcoming schedule overrides',
      subtitle:
        'The following schedule overrides are configured for this location in the Toast dashboard.',
      infobox_content:
        'No upcoming schedule overrides are configured for this location.',
      closed_all_day: 'Closed all day',
      header_date: 'Date',
      header_hours: 'Hours',
      header_handoff: 'Handoff',
      handoff_mode: {
        pickup: 'Pickup',
        delivery: 'Delivery',
        dine_in: 'Dine-in',
      },
    },
    menus: {
      menu: 'Menu',
      enabled: {
        title: 'Menus enabled for this location',
        subtitle:
          'These menus are associated with this location by your ordering provider and are enabled for use by the Thanx ordering experiences.',
        infobox_content:
          'These menus are associated with this location by your ordering provider and are enabled for use by the Thanx ordering experiences.',
      },
      disabled: {
        title: 'Menus not enabled for this location',
        subtitle:
          'These menus are associated with this location by your ordering provider but are not enabled for use by the Thanx ordering experiences.',
        infobox_content:
          'No menus are associated with this location but not enabled for use by the Thanx ordering experiences.',
      },
    },
    help: {
      help: 'Help',
      link: 'How to troubleshoot menu errors',
    },
  },
  empty_state: {
    title: 'No locations are available for ordering right now',
    description: 'Please come back later.',
    refresh: 'Refresh',
  },
}

export default orderingManagement
